export const DEFAULT_USER_ACTIVITY = {
    localState: {},
}
